module.exports = __webpack_public_path__ + "static/media/11.9c880100.jpg";